<template>
  <aside class="main-sidebar">
    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">

      <!-- Sidebar company panel (optional) -->
      <!-- <div class="user-panel" style="text-align: center">
        <div class="image">
          <img :src="pictureUrl" />
        </div>       
      </div> 
      <div style="text-align: center" v-if="this.$store.state.show_empresa">
      <h4 style="color: white">{{empresa}}</h4>
      </div>
      -->
      
      <!-- search form (Optional) -->
      <form v-on:submit.prevent class="sidebar-form">
        <div class="input-group">
          <input type="text"
            name="search"
            id="search"
            class="search form-control"
            data-toggle="hideseek" 
            placeholder="Search Menus"
            data-list=".sidebar-menu">
          <span class="input-group-btn">
            <button type="submit" name="search" id="search-btn" class="btn btn-flat">
              <i class="fa fa-search"></i>
            </button>
          </span>
        </div>
      </form>
      <!-- /.search form -->

      

      <!-- Sidebar Menu -->
      <sidebar-menu />
      <!-- /.sidebar-menu -->
    </section>
    <!-- /.sidebar -->
  </aside>
</template>
<script>
import SidebarMenu from './SidebarMenu'
import firebase from 'firebase'
import axios from 'axios'

export default {
  name: 'Sidebar',
  props: ['displayName', 'pictureUrl', 'empresa'],
  components: { 
    SidebarMenu
  },
  mounted: function () {
    window.jQuery('[data-toggle="hideseek"]').off().hideseek()
  },
  methods: {
    logout () {
      firebase.auth().signOut().then(() => {
        console.log('saiu')
        this.$router.replace('login')
      })
    }
  }
}
</script>
<style>
.user-panel {
    height: 6em;
}
.image {
      height: 100%;
}
  .user-panel .image img {
        width: 100%;
    max-width: 100px;
    height: auto;

  }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?1e1353a0